import { Outlet } from 'react-router-dom'
import TabelaGrupoMinisterio from './components/tabela'

export default function GrupoMinisterio() {

  return (
    <>
      <Outlet />
      <TabelaGrupoMinisterio />
    </>
  )
}
